import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import { constantRoutes } from '@/router'
import { generatorDynamicRouter } from '@/router/generator-router'

import store from '@/store'

const hasPermission = (accessList: string[], route: RouteConfig) => {
  if (route.meta && route.meta.access) {
    return accessList.some(access => route?.meta?.access.includes(access))
  } else {
    return true
  }
}

export const filterAsyncRoutes = (routes: RouteConfig[], accessList: string[]) => {
  const res: RouteConfig[] = []
  routes.forEach(route => {
    const r = { ...route }
    if (hasPermission(accessList, r)) {
      if (r.children) {
        r.children = filterAsyncRoutes(r.children, accessList)
      }
      res.push(r)
    }
  })
  return res
}

export interface IPermissionState {
  routes: RouteConfig[]
  dynamicRoutes: RouteConfig[]
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = []
  public dynamicRoutes: RouteConfig[] = []

  @Mutation
  private SET_ROUTES (routes: RouteConfig[]) {
    this.routes = constantRoutes.concat(routes)
    this.dynamicRoutes = routes
  }

  @Action
  public GenerateRoutes (asyncRoutes: object[]) {
    return new Promise(resolve => {
      // generatorDynamicRouter(asyncRoutes).then((res:any) => {
      //   this.SET_ROUTES(res)
      //   resolve(res)
      // })
      generatorDynamicRouter().then((res:any) => {
        this.SET_ROUTES(res)
        resolve(res)
      })
    })
  }
}

export const PermissionModule = getModule(Permission)
